import React from 'react';

export const Decision = ({
  className,
  color,
  width,
  height,
}: {
  className?: string;
  color?: string;
  width?: number;
  height?: number;
}) => (
  <svg
    width={width ?? 25}
    height={height ?? 24}
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.1126 11.25L9.1126 9.16726V9.16667L9.1126 7.91667L4.37338 7.91667L3.49446 9.61153L4.36307 11.25L9.1126 11.25ZM9.1126 12.9167L3.86165 12.9167C3.55314 12.9167 3.26988 12.7462 3.12538 12.4737L1.81726 10.0061C1.6891 9.76436 1.68779 9.47508 1.81375 9.23217L3.12703 6.6997C3.2703 6.42342 3.55559 6.25 3.86681 6.25L9.1126 6.25V4.16667V4.16644V3.33333L9.94594 3.33333L10.7793 3.33333L16.0302 3.33333C16.3387 3.33333 16.622 3.50377 16.7665 3.77635L18.0746 6.24388C18.2028 6.48565 18.2041 6.77492 18.0781 7.01783L16.7648 9.5503C16.6216 9.82658 16.3363 10 16.0251 10H10.7793L10.7793 12.0833L10.7793 16.6667L9.1126 16.6667L9.1126 12.9167ZM10.7793 8.33333H15.5185L16.3974 6.63847L15.5288 5L10.7793 5L10.7793 7.08333L10.7793 8.33333Z"
      fill={color ?? '#6E6B8C'}
    />
  </svg>
);
